import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { postsAPI } from '@/services/postsApi';
import { queryKeys } from './queryKeys';

export function usePosts() {
  return useQuery({
    queryKey: queryKeys.posts.all(),
    queryFn: () => postsAPI.getPosts(),
  });
}

export function useCreatePost() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => postsAPI.createPost(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.posts._def }),
  });
}

export function useUpdatePost() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => postsAPI.updatePost(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.posts._def }),
  });
}

export function useDeletePost() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => postsAPI.deletePost(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.posts._def }),
  });
}
